import {
  Component,
  Input,
  Output,
  EventEmitter
} from "@angular/core";
import { Observable } from "rxjs/Observable";
import { isUndefined } from "util";
import 'rxjs/Rx'
@Component({
  selector: "app-table",
  templateUrl: "./table.component.html",
  styleUrls: ["./table.component.css"]
})
export class TableComponent {

  @Input() config: any;
  @Input() size: number;
  @Input() limit: number;
  @Output() pageChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() getPage: any;
  @Output() ActionEvent: EventEmitter<any> = new EventEmitter<any>();
  searchText: string = "";
  currentPage: number;
  totalPage: number;
  totalPages: number;
  pages: Observable<number[]>;
  limitList: any[];
  loaded = false;
  pp: string = "json";
  p: number = 0;
  constructor() { }
  ngOnInit() {
    if (!this.config.Access) {
      this.config.Access = { save: true, edit: true, delete: true, view: true }
    }
    this.limitList = [10, 25, 50];
    this.getPages(this.config.offset, this.limit, this.size);
    this.searchText = isUndefined(this.getPage.searchText) ? "" : this.getPage.searchText;

  }
  onChange(i) {
    this.limit = i;
    this.selectPage(1);
  }
  ngOnChanges() {
    //this.getPages(this.config.offset, this.limit, this.size, this.currentPage);
  }
  ActionEvents(type: number, v: any) {
    this.ActionEvent.emit({ type: type, data: v });
  }
  selectPage(page: number) {

    if (this.isValidPageNumber(page, this.totalPage)) {
      this.p = page;
      this.currentPage = page;
      this.getPages(this.config.offset, this.limit, this.size);
      this.setPages();
      this.pageChange.emit({
        page: page,
        limit: this.limit,
        start: page * this.limit - this.limit,
        searchText: this.searchText
      });
    }
  }
  searchKeyPress(e) {
    if (e.keyCode == 13 && e.which == 13) {
      this.searchText = e.target.value;
      this.selectPage(1);
    }
  }
  getPages(offset: number, limit: number, size: number) {
    this.currentPage = this.getPage.page; //this.getCurrentPages(offset, limit);
    this.totalPage = this.getTotalPages(limit, size);
    this.setPages();
  }
  setPages() {
    this.pages = Observable.range(-this.config.range, this.config.range * 2 + 1)
      .map(offset => this.currentPage + offset)
      .filter(page => this.isValidPageNumber(page, this.totalPage))
      .toArray();
  }
  getCurrentPages(offset: number, limit: number): number {
    return Math.floor(offset / limit) + 1;
  }
  getTotalPages(limit: number, size: number): number {
    return Math.ceil(Math.max(size, 1) / Math.max(limit, 1));
  }
  isValidPageNumber(page: number, totalPages: number): boolean {
    return page > 0 && page <= totalPages;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/table/table.component.ts